// src/features/organisation/hooks/useDepartments.ts
import { useState, useEffect } from 'react';
import { apiClient } from '../../../services/api/client';
import { Department, DepartmentCreateDto } from '../../../types/organisation';

export const useDepartments = () => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const data = await apiClient.get('/organisation/departments');
      setDepartments(data || []);
      setError(null);
    } catch (err) {
      setError(err as Error);
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const createDepartment = async (data: DepartmentCreateDto): Promise<Department> => {
    const newDepartment = await apiClient.post('/organisation/departments', data);
    await fetchDepartments(); // Rafraîchir la liste
    return newDepartment;
  };

  const updateDepartment = async (id: number, data: DepartmentCreateDto): Promise<Department> => {
    const updatedDepartment = await apiClient.put(`/organisation/departments/${id}`, data);
    await fetchDepartments(); // Rafraîchir la liste
    return updatedDepartment;
  };

  const deleteDepartment = async (id: number): Promise<void> => {
    await apiClient.delete(`/organisation/departments/${id}`);
    await fetchDepartments(); // Rafraîchir la liste
  };

  return { 
    departments, 
    loading, 
    error, 
    refresh: fetchDepartments,
    createDepartment,
    updateDepartment,
    deleteDepartment
  };
};